import { User } from '@graphics/gfx-common/dist/types'
import { ICapability, ICapabilityFormValues } from '../types/capability'
import { IPublishingLocation } from '../types/publishingLocations'
import { IGroupDetailed } from '../types/group'
import { safePost, safeGet, safePut, safeDelete, groupsHostUrl } from './http'
import { matchId } from './common'
import * as date from './date'

const capabilityUrl = `${groupsHostUrl}/publishing-capabilities`

export const createCapability = (capabilityData: ICapability) =>
  safePost(capabilityUrl, capabilityData)

export const getCapabilities = () => safeGet(`${capabilityUrl}`)

export const getCapability = (id: string) => safeGet(`${capabilityUrl}/${id}`)

export const updateCapability = (capabilityData: ICapability) =>
  safePut(`${capabilityUrl}/${capabilityData.id}`, capabilityData)

export const deleteCapability = (id: string) =>
  safeDelete(`${capabilityUrl}/${id}`)

export const transformCapabilityStateToInput = (
  capability: ICapability
): ICapabilityFormValues => ({
  ...capability,
  publishingLocation: !!capability.publishingLocation
    ? capability.publishingLocation.name
    : '',
})

export const transformCapabilityInputToState = (
  values: ICapabilityFormValues,
  publishingLocations: IPublishingLocation[]
): ICapability => ({
  ...values,
  publishingLocation: publishingLocations.find(
    (item) => item.name === values.publishingLocation
  ),
})

export const createGetCapabilityApprovalStatus = (group: IGroupDetailed) => (
  capabilityId: string
): {
  label: string
  tooltipTitle: string
} => {
  const groupCapability = group.capabilities.find(matchId(capabilityId)) as
    | ICapability
    | undefined
  return {
    label: !groupCapability
      ? 'Requires approval'
      : groupCapability.approved
      ? 'Approved'
      : 'Pending',
    tooltipTitle:
      groupCapability && groupCapability.approved && groupCapability.approvedBy
        ? `Approved by ${
            ((groupCapability as ICapability).approvedBy as User).name
          } on ${date.format(groupCapability.approvalDate as string, 'SHORT')}`
        : '',
  }
}

export const createIsPendingApproval = (group: IGroupDetailed) => (
  capabilityId
): boolean => {
  const capability = group.capabilities.find(matchId(capabilityId))
  return !!capability && !(capability as ICapability).approved
}
